import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconSeats: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 40 40" name="seats">
    <path
      fillRule="evenodd"
      d="M16.833 9.734V7.5a2.667 2.667 0 0 0-2.666-2.667h-2.5A2.667 2.667 0 0 0 9 7.5v3.305c0 1.915 1.957 3.206 3.717 2.452l2.5-1.072a2.667 2.667 0 0 0 1.616-2.451Zm-2-2.234v2.234a.667.667 0 0 1-.404.613l-2.5 1.071a.667.667 0 0 1-.929-.613V7.5c0-.369.299-.667.667-.667h2.5c.368 0 .666.298.666.667ZM9.532 18.336a2.878 2.878 0 0 1 2.81-3.503c2 0 3.854 1.05 4.883 2.765l2.48 4.132a4.333 4.333 0 0 1-.03 4.508l7.578-.42a4.261 4.261 0 0 1 4.37 3.22c.673 2.69-1.361 5.295-4.134 5.295H16.17c-2.068 0-3.536-1.53-3.802-3.285l-.01.002-2.825-12.714Zm8.323 7.023-.767 1.023-.633.035a4.547 4.547 0 0 0-2.815 1.184l-2.156-9.7a.878.878 0 0 1 .857-1.068c1.298 0 2.501.681 3.17 1.794l2.478 4.132a2.333 2.333 0 0 1-.134 2.6Zm11.828 4.164a2.261 2.261 0 0 0-2.319-1.709l-10.798.6a2.547 2.547 0 0 0-1.792.886c-1.022 1.192-.175 3.033 1.395 3.033h11.32a2.261 2.261 0 0 0 2.194-2.81Z"
      clipRule="evenodd"
    />
  </Icon>
);
